import client from "./client";

export const adminApi = {
  // Users
  listUsers:    ()           => client.get("/admin/users"),
  createUser:   (data)       => client.post("/admin/users", data),
  updateUser:   (id, data)   => client.patch(`/admin/users/${id}`, data),
  deleteUser:   (id)         => client.delete(`/admin/users/${id}`),
  // Entities
  listEntities:   ()          => client.get("/admin/entities"),
  createEntity:   (data)      => client.post("/admin/entities", data),
  updateEntity:   (id, data)  => client.patch(`/admin/entities/${id}`, data),
  deleteEntity:   (id)        => client.delete(`/admin/entities/${id}`),
};
